export const FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST =
    'FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST';
export const FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS =
    'FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS';
export const FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE =
    'FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE';
export const FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP =
    'FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP';
export const UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM =
    'UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM';
